import React from 'react';
import {
  Content,
  Row,
  Col,
  Title,
  //  Text, Button,
  Pagination,
} from 'components';
import { SideMenu } from 'routes/main.routes/Mypage/components';
import {
  Empty,
  //  Input
} from 'antd';
// import search from 'assets/search.svg';
import keep from 'assets/keep.svg';
import moment from 'moment';
import { csMenu } from '../csMenu';
import { encrypt } from 'utils/Crypto';

const PAGE_SIZE = 8;

const HelpNoticePresenter = (props) => {
  /* ===== Props ===== */
  const { navigate, currentPage, setCurrentPage, notices, screenSize } = props;
  // const [activeButton, setActiveButton] = useState('전체');

  /* ===== Hooks ===== */
  /**
   * 공지사항 목록 정제
   * --
   */
  const noticeList = React.useMemo(() => {
    let newList = [];

    Object.entries(notices).forEach(([key, value]) => {
      const newValue = value.map((_item) => ({
        key: key,
        ..._item,
      }));

      newList = newList.concat(newValue);
    });

    return newList;
  }, [notices]);

  /* ===== Variables ===== */
  const styles = {
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 24,
      borderBottom: '2px solid var(--black-color)',
    },
    title: {
      fontSize: screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
      fontWeight: 700,
      color: 'var(--black-color)',
    },
    button: {
      padding: '10px 29px',
      borderRadius: '2px',
      backgroundColor: 'transparent',
      border: '1px solid var(--dark-gray-color)',
      color: 'var(--black-color)',
    },
    activeButton: {
      padding: '10px 29px',
      borderRadius: '2px',
      backgroundColor: 'var(--black-color)',
      color: 'white',
    },
    notice: {
      width: '100%',
      padding: '32px 0',
      borderBottom: '1px solid #ddd',
      cursor: 'pointer',
      fontSize: 16,
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: screenSize >= 768 ? 'unset' : 'column',
      rowGap: screenSize >= 768 ? 20 : 10,
    },
  };

  return (
    <Content
      maxWidth={1820}
      padding={screenSize >= 768 ? '120px 0px' : '80px 0'}
    >
      <Row gutter={25}>
        <Col x={0} md={2}></Col>
        <Col x={0} md={4}>
          <SideMenu menu={csMenu} title="고객센터" />
        </Col>
        <Col x={24} md={16}>
          <Content
            maxWidth={'100%'}
            padding={screenSize >= 768 ? '0 0 0 95px' : '0'}
          >
            <div style={styles.titleLayout}>
              <Title style={styles.title}>공지사항</Title>
            </div>

            {/* <div
              style={{
                padding: '32px 0',
                display: 'flex',
                gap: 16,
                borderBottom: '1px solid var(--black-color)',
              }}
            >
              {['전체', 'NEWS', 'EVENT'].map((buttonLabel) => (
                <Button
                  key={buttonLabel}
                  style={
                    activeButton === buttonLabel
                      ? styles.activeButton
                      : styles.button
                  }
                  onClick={() => handleStatusChange(buttonLabel)}
                >
                  {buttonLabel}
                </Button>
              ))}
              <div
                style={{
                  position: 'relative',
                  width: '35%',
                  marginLeft: 'auto',
                }}
              >
                <Input style={{ width: '100%', height: '100%' }} />
                <img
                  src={search}
                  alt="search icon"
                  style={{
                    cursor: 'pointer',
                    position: 'absolute',
                    top: '50%',
                    right: '20px',
                    transform: 'translateY(-50%)',
                  }}
                />
              </div>
            </div> */}

            <Content maxWidth={'100%'} padding={0}>
              {noticeList.length ? (
                <div>
                  {noticeList
                    .slice(
                      (currentPage - 1) * PAGE_SIZE,
                      currentPage * PAGE_SIZE
                    )
                    .map((notice) => (
                      <div
                        key={`${notice.key}-${notice.id}`}
                        style={styles.notice}
                        onClick={() =>
                          navigate(
                            `/cs/notice/${encodeURIComponent(
                              encrypt(notice.id)
                            )}`
                          )
                        }
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: screenSize >= 768 ? 'auto' : '100%',
                          }}
                        >
                          <div
                            style={{
                              width: 40,
                              marginRight: screenSize >= 768 ? 24 : 0,
                              fontWeight: 700,
                            }}
                          >
                            {notice.key === 'fixed' ? (
                              <img
                                src={keep}
                                alt="keep icon"
                                style={styles.fixedIcon}
                              />
                            ) : (
                              <span>{notice.no}</span>
                            )}
                          </div>
                          <span
                            style={{
                              border: '1px solid var(--black-color)',
                              padding: '2px 8px',
                              marginRight: screenSize >= 768 ? '8px' : 0,
                              minWidth: 46,
                              wordBreak: 'keep-all',
                            }}
                          >
                            {notice.status}
                          </span>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%',
                            alignItems: screenSize >= 768 ? 'center' : 'start',
                            flexDirection:
                              screenSize >= 768 ? 'unset' : 'column',
                            gap: screenSize >= 768 ? 0 : 10,
                            paddingLeft: screenSize >= 768 ? 0 : 40,
                          }}
                        >
                          <div
                            style={{
                              width: screenSize >= 768 ? '80%' : '100%',
                            }}
                          >
                            {notice.title}
                          </div>
                          {moment(notice.create_date).format('YYYY.MM.DD')}
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <div style={{ marginTop: 30 }}>
                  <Empty description={'등록된 공지사항이 없습니다.'} />
                </div>
              )}
            </Content>
            <div style={{ marginTop: screenSize >= 768 ? 100 : 60 }}>
              <Pagination
                total={noticeList.length}
                PAGE_SIZE={PAGE_SIZE}
                showPage={5}
                currentPage={currentPage}
                onChange={(page) => setCurrentPage(page)}
                buttonStyle={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: '#999999',
                  background: 'none',
                  width: 28,
                  height: 28,
                }}
                isButton={true}
                activeStyle={{
                  color: `var(--black-color) !important`,
                  borderBottom: '2px solid #111111',
                }}
                hoverStyle={{
                  color: `var(--black-color) !important`,
                }}
                navStyle={{
                  border: '1px solid var(--black-color)',
                }}
                isLatestButton={true}
              />
            </div>
          </Content>
        </Col>
        <Col x={0} md={2}></Col>
      </Row>
    </Content>
  );
};

export default HelpNoticePresenter;
